var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13773",
    "data-name": "Group 13773",
    transform: "translate(-117.88 -372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18439",
    "data-name": "Rectangle 18439",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V12a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(117.88 382)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18440",
    "data-name": "Rectangle 18440",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V22a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(123.88 372)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18441",
    "data-name": "Rectangle 18441",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V16a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(129.88 378)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18442",
    "data-name": "Rectangle 18442",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V20a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(135.88 374)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/Poll.01624a5b81cffd8eddc48f13986d2127.svg";
export { ForwardRef as ReactComponent };